import React from "react";
import styled, { keyframes } from "styled-components";

const lightning1 = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  50% {
    opacity: 0.7;
    transform: translate(-5px, 8px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const lightning2 = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  50% {
    opacity: 0.7;
    transform: translate(16px, -2px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const lightning3 = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  50% {
    opacity: 0.7;
    transform: translate(5px, 8px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const lightning4 = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  50% {
    opacity: 0.7;
    transform: translate(10px, 2px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const AnimatedPath1 = styled.path`
  animation: ${lightning1} 1s ease-out infinite;
  animation-play-state: ${({ isActive }) => (isActive ? "running" : "paused")};
`;

const AnimatedPath2 = styled.path`
  animation: ${lightning2} 1s ease infinite;
  animation-play-state: ${({ isActive }) => (isActive ? "running" : "paused")};
`;

const AnimatedPath3 = styled.path`
  animation: ${lightning3} 1s ease-out infinite;
  animation-play-state: ${({ isActive }) => (isActive ? "running" : "paused")};
`;

const AnimatedPath4 = styled.path`
  animation: ${lightning4} 1s ease-in-out infinite;
  animation-play-state: ${({ isActive }) => (isActive ? "running" : "paused")};
`;

const StripesMCSvg = ({ isActive }) => {
  return (
    <svg
      width="249"
      height="133"
      viewBox="0 0 249 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <AnimatedPath1
        isActive={isActive}
        d="M205.021 72.2917L195 92.3334L221.351 61.1875L211.33 66.0625L231 40.3334H210.588L198.711 74.4584L205.021 72.2917Z"
        fill="white"
      />
      <AnimatedPath2
        isActive={isActive}
        d="M208.101 100.341L187 107.879L227.575 103.622L216.967 100.209L248.97 95.2407L234.232 81.118L202.047 97.5402L208.101 100.341Z"
        fill="white"
      />
      <AnimatedPath3
        isActive={isActive}
        d="M45.3093 27.823L57 51.3334L26.2577 14.7969L37.9485 20.5157L15 -9.66663H38.8144L52.6701 30.3646L45.3093 27.823Z"
        fill="white"
      />
      <AnimatedPath4
        isActive={isActive}
        d="M40.8686 65.341L61.9699 72.8785L21.3954 68.6217L32.0034 65.2086L-0.000133276 60.2407L14.7381 46.118L46.9231 62.5402L40.8686 65.341Z"
        fill="white"
      />
    </svg>
  );
};

export default StripesMCSvg;
